module.exports = {"id":"186672","name":"Geoff Cameron","rating":"76","photo":"./data/images/photos/1/186672.png","club":{"name":"Stoke City","logo":"./data/images/clubs/StokeCity.png"},"positions":["MDC","DC","MC","DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GeoffCameron0.json
// module id = 1551
// module chunks = 0